module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.computedClass
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-label",
    class: {
      'no-padding': _vm.helpIcon
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.helpIcon) ? _c('help-icon', {
    attrs: {
      "popperOptions": _vm.helpIconOptions,
      "size": "small"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input text-input",
    attrs: {
      "readonly": _vm.readonly,
      "optional": !_vm.required,
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input text-input",
    attrs: {
      "readonly": _vm.readonly,
      "optional": !_vm.required,
      "type": "email",
      "id": _vm.name,
      "name": _vm.name,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input textarea-input",
    attrs: {
      "optional": !_vm.required,
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input password-input",
    attrs: {
      "id": _vm.name,
      "name": _vm.name,
      "type": "password",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type == 'select') ? _c('div', {
    staticClass: "field--wrapper input--select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input field--select input--select",
    attrs: {
      "disabled": _vm.readonly || _vm.disabled,
      "id": _vm.name,
      "name": _vm.name
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChange($event)
      }]
    }
  }, [_c('option', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": undefined
    }
  }), _vm._v(" "), _vm._l((_vm.collection), function(option) {
    return _c('option', {
      key: option.value,
      attrs: {
        "disabled": (option.disabled == 'true'),
        "name": option.value
      },
      domProps: {
        "selected": option.value == _vm.newValue,
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('div', {
    staticClass: "field--wrapper"
  }, _vm._l((_vm.collection), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "field--radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "input--radio",
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '-' + option.value,
        "item": _vm.value,
        "disabled": _vm.disabled
      },
      domProps: {
        "value": option.value,
        "checked": option.value == _vm.newValue,
        "checked": _vm._q(_vm.newValue, option.value)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(option.value)
        },
        "change": function($event) {
          _vm.newValue = option.value
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.name + '-' + option.value
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type == 'checkbox') ? _c('div', {
    staticClass: "field--wrapper"
  }, _vm._l((_vm.collection), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "field--checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      staticClass: "input--checkbox",
      attrs: {
        "type": "checkbox",
        "id": _vm.name + '-' + option.value,
        "item": _vm.value,
        "checked": "",
        "disabled": _vm.disabled
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, option.value) > -1 : (_vm.newValue)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(option.value)
        },
        "change": function($event) {
          var $$a = _vm.newValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.name + '-' + option.value
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0249bd6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/FormField.vue
// module id = 1793
// module chunks = 0